import { FlatpickrDefaultsInterface } from 'angularx-flatpickr';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

export class DatePickerConf implements FlatpickrDefaultsInterface {
  dateFormat: string = 'd/m/Y';
  locale: string | object = Portuguese;
  allowInput: boolean = true;
}
